import { render, staticRenderFns } from "./childStarCard.vue?vue&type=template&id=9273ece6&scoped=true&"
import script from "./childStarCard.vue?vue&type=script&lang=js&"
export * from "./childStarCard.vue?vue&type=script&lang=js&"
import style0 from "./childStarCard.vue?vue&type=style&index=0&id=9273ece6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9273ece6",
  null
  
)

export default component.exports